module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"copied_to_clipboard":"Copied to clipboard","embedded_title":"Embedded code"},"ua":{"copied_to_clipboard":"Copied to clipboard","embedded_title":"Вбудований код"},"ru":{"copied_to_clipboard":"Copied to clipboard","embedded_title":"Встроенный код"}}')
  delete Component.options._Ctor
}
